module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot3-3bdc65820e24dbbc6a08af630c725da1.png";